export default __webpack_public_path__ + "static/slide3-9107b2e1778c43f7ab29dd4890f182ad.jpg";